import { Component, OnInit, ElementRef, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {MatSnackBar} from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../../services/auth.service';
import { NavService } from 'src/app/services/nav.service';
import { CallService } from '../../services/call.service';
import { ReservationService } from 'src/app/services/reservation.service';

import { environment } from '../../../environments/environment';

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { VRM, VRMSchema } from '@pixiv/three-vrm';
declare const JEEFACETRANSFERAPI: any;
import Peer from 'skyway-js';

import { Live2DCubismFramework as live2dcubismframework } from '../../../assets/js/live2d/Framework/src/live2dcubismframework';
import CubismFramework = live2dcubismframework.CubismFramework;
import { Live2DCubismFramework as cubismmodelsettingjson } from '../../../assets/js/live2d/Framework/src/cubismmodelsettingjson';
import CubismModelSettingJson = cubismmodelsettingjson.CubismModelSettingJson;
import { Live2DCubismFramework as icubismmodelsetting } from '../../../assets/js/live2d/Framework/src/icubismmodelsetting';
import ICubismModelSetting = icubismmodelsetting.ICubismModelSetting;
import { Live2DCubismFramework as cubismmatrix44 } from '../../../assets/js/live2d/Framework/src/math/cubismmatrix44';
import CubismMatrix44 = cubismmatrix44.CubismMatrix44;
import { AppCubismUserModel } from '../../../assets/js/live2d/AppCubismUserModel';

@Component({
  selector: 'app-avatar-call',
  templateUrl: './call.component.html',
  styleUrls: ['./call.component.scss']
})
export class AvatarCallComponent implements OnInit, OnDestroy {
  // VRMを表示するためのvideo要素
  @ViewChild('video', {static: true}) video: ElementRef;
  @ViewChild('canvas', {static: true}) canvas: ElementRef;
  @ViewChild('audio', {static: true}) audio: ElementRef;
  @ViewChild('content', {static: true}) content: ElementRef;

  // ローディングメッセージ
  loadMsg = 'ロード中...';

  // ユーザーデータ
  user: any;
  // 通話相手のユーザーデータ
  partner: any;
  // 通話相手のアバター種別
  isVrm: boolean;

  // 予約UID
  reservationUid: any;
  // 予約データ
  reservation: any;

  // VRMアバターパス
  model: any;
  // 現在ロードされているVRMアバター
  currentVrm: any;

  // Live2Dデータ
  model3json: any;
  moc3: any;
  textures = [];
  pose: any;
  physics: any;

  // Jeelizのロード完了フラグ
  isJeelizReady = false;

  // SkywayのPeer
  peer: any;
  // skywayのPeer接続フラグ
  isPeerOpen = false;
  // データ通信接続確認フラグ
  isConnected = false;
  // データ通信
  // dataConnection: any;
  // データルーム
  room: any;
  // 音声通話のCall
  existingCall: any;
  // 自分の音声ストリーム
  myAudio: any;

  // 通話相手から受信した表情とモーションデータ
  theirFace: any;
  theirRotation: any;

  // ミュートフラグ
  muted = false;

  // 通話終了フラグ
  isCallEnd = false;

  // ダブルタップ防止用
  tapCount = 0;

  // ロード画面を非表示にするためのフラグ
  isModelLoaded = false;

  // モデルごとの表示サイズ設定
  settings: Array<number>;

  constructor(
    public auth: AuthService,
    private nav: NavService,
    private call: CallService,
    private rs: ReservationService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private modalService: NgbModal,
  ) {}

  @HostListener('mousewheel', ['$event']) onMousewheel(event) {
    event.preventDefault();
  }
  @HostListener('touchmove', ['$event']) onTouchMove(event) {
    event.preventDefault();
  }
  @HostListener('touchstart', ['$event']) onTouchStart (event) {
    // シングルタップの場合
    if ( !this.tapCount ) {
      // タップ回数を増加
      ++this.tapCount ;

      // 350ミリ秒だけ、タップ回数を維持
      setTimeout( () => {
        this.tapCount = 0 ;
      }, 350 ) ;

    // ダブルタップの場合
    } else {
      // ビューポートの変更(ズーム)を防止
      event.preventDefault() ;

      // タップ回数をリセット
      this.tapCount = 0 ;
    }
  }

  async ngOnInit() {
    window.scroll(0, 0);

    // モーダルを表示
    this.modalService.open(this.content, { centered: true, scrollable: true }).result.then(result => {
      if (result === 'Close click') {
        // タップ回数を増加
        ++this.tapCount ;
        // 350ミリ秒だけ、タップ回数を維持
        setTimeout( () => {
          this.tapCount = 0 ;
        }, 350 ) ;
      }
    });

    // ヘッダーとフッターを非表示に設定
    setTimeout(() => {
      this.nav.hide();
    });

    // 自分のユーザーデータを取得
    this.user = Object.assign({}, this.auth.user);
    if (typeof this.user === 'undefined') {
      this.error('this.user=undefined');
      // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
    }
    // console.log('this.user: ', this.user);

    // URLから予約UIDを取得
    this.reservationUid = this.route.snapshot.paramMap.get('uid');
    if (typeof this.reservationUid === 'undefined') {
      this.error('reservationUid=undefined');
      // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
    }
    // console.log('this.uid: ', this.reservationUid);

    // 予約情報を取得
    this.reservation = await this.call.getReservationByUid(this.reservationUid).toPromise();
    if (typeof this.reservation === 'undefined') {
      this.error('reservation=undefined');
      // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
    }
    // console.log('this.reservation: ', this.reservation);

    // 時間外だったら強制退出
    if (!this.dateCheck()) {
      return;
    }

    // 予約情報に入室時間をセット
    this.setOpenTime();

    // 通話相手のユーザーデータを取得
    if (this.user.role === AuthService.VTUBER_ROLE) {
      const partner = await this.auth.getUserByUid(this.reservation.user_uid).toPromise();
      this.partner = partner[0];
      // console.log('this.partner: ', this.partner);
    } else {
      const partner = await this.auth.getUserByUid(this.reservation.vtuber_uid).toPromise();
      this.partner = partner[0];
      // console.log('this.partner: ', this.partner);
    }

    // アバター種別のフラグをセット
    this.isVrm = this.partner.profile.modelType === 'vrm' ? true : false;
    // console.log('modelType: ', this.partner.profile.modelType);
    // console.log('this.isVrm: ', this.isVrm);

    // ここで通話相手のVRM,Live2Dデータをダウンロード
    // this.model = 'https://firebasestorage.googleapis.com/v0/b/laer-39ee6.appspot.com/o/users%2FsmJAzuUzdJYl2fqnKa4KpvlORfT2%2Fvrm_file?alt=media&token=1ecca57a-4001-4c27-b022-9a373b32bf18';
    if (this.isVrm) {
      // VRMファイルの読み込み
      this.model = this.partner.profile.vrm.url;
      if (this.partner.profile.vrm.settings) {
        this.settings = this.partner.profile.vrm.settings;
      } else {
        this.settings = [6, 0.1, 20.0, 0.0, 1.47, 4.1];
      }
    } else {
      // Live2Dファイルの読み込み
      // this.model3json = 'https://firebasestorage.googleapis.com/v0/b/laer-39ee6.appspot.com/o/users%2FsmJAzuUzdJYl2fqnKa4KpvlORfT2%2Fmodel_file?alt=media&token=9e6da887-cce4-485c-a088-f74c0b431065';
      // this.moc3 = 'https://firebasestorage.googleapis.com/v0/b/laer-39ee6.appspot.com/o/users%2FsmJAzuUzdJYl2fqnKa4KpvlORfT2%2Fmoc_file?alt=media&token=ac29cf84-bf6f-4ddb-8d3c-650a203a238b';
      // this.textures = ['../../../assets/newmint/newmint.2048/texture_00.png', '../../../assets/newmint/newmint.2048/texture_01.png'];
      this.model3json = this.partner.profile.live2d.filemodel.url;
      this.moc3 = this.partner.profile.live2d.filemoc.url;
      const textures = this.partner.profile.live2d.file2048;
      const textureCount = textures.length;
      for (let i = 0; i < textureCount; i++) {
        this.textures.push(textures[i].url);
      }
      if (this.textures.length === 0) {
        // console.log('no textures');
        return;
      }
      if (typeof this.partner.profile.live2d.filepose !== 'undefined') {
        this.pose = this.partner.profile.live2d.filepose.url;
      }
      if (typeof this.partner.profile.live2d.filephysics !== 'undefined') {
        this.physics = this.partner.profile.live2d.filephysics.url;
      }
      if (this.partner.profile.live2d.settings) {
        this.settings = this.partner.profile.live2d.settings;
      } else {
        this.settings = [5, 1.4];
      }
    }

    // Jeelizの初期化処理
    this.initJeeliz();

    this.loadMsg = '接続中...';
    // Skywayの初期化
    this.initSkyway();

    const render = setInterval(() => {
      if (this.isJeelizReady && this.isConnected) {
        // console.log('JeelizとSkywayの準備完了');
        clearInterval(render);

        this.loadMsg = `${this.partner.displayName}さんの到着を待っています...`;
        if (this.isVrm) {
          // console.log('VRM読み込み');
          // VRM用の処理
          this.initVrm();
        } else {
          // live2d用の処理
          this.initLive2d();
          // console.log('Live2D読み込み');
        }
      } else {
        // console.log('JeelizとSkywayの準備が終わるまで繰り返し');
        // console.log('this.isJeelizReady: ', this.isJeelizReady);
        // console.log('this.isConnected: ', this.isConnected);
      }
    }, 500);
  }

  // 通話時間外の場合強制退出
  dateCheck() {
    // 現在日時を取得
    const now = new Date();
    // console.log('now: ', now);

    // 予約日を取得
    const reserveDate = this.reservation.reserveAt;
    // console.log('reserveDate: ', reserveDate);
    const reserveYear = Number(reserveDate.slice(0, 4));
    const reserveMonth = Number(reserveDate.slice(5, 7));
    const reserveDay = Number(reserveDate.slice(-2));
    // console.log('reserveYear: ', reserveYear);
    // console.log('reserveMonth: ', reserveMonth);
    // console.log('reserveDay: ', reserveDay);

    // 開始日時を取得
    const start = this.reservation.start;
    // console.log('start: ', start);
    const startHour = Number(start.slice(0, 2));
    const startMinutes = Number(start.slice(-2));
    // console.log('startHour: ', startHour);
    // console.log('startMinutes: ', startMinutes);
    const startDate = new Date(reserveYear, reserveMonth - 1, reserveDay, startHour, startMinutes);
    // console.log('startDate: ', startDate);

    // 終了日時を取得
    const end = this.reservation.end;
    // console.log('end: ', end);
    const endHour = Number(end.slice(0, 2));
    const endMinutes = Number(end.slice(-2));
    // console.log('endHour: ', endHour);
    // console.log('endMinutes: ', endMinutes);
    const endDate = new Date(reserveYear, reserveMonth - 1, reserveDay, endHour, endMinutes);
    // console.log('endDate: ', endDate);

    // 開始日時を過ぎているか確認
    if (startDate.getTime() > now.getTime()) {
      alert('通話時間外です');
      setTimeout(() => {
        window.location.href = 'https://laer.jp/rooms';
      }, 2000);
      return false;
    } else if (endDate.getTime() <= now.getTime()) {
      // 終了日時を過ぎているか確認
      alert('通話時間外です');
      setTimeout(() => {
        window.location.href = 'https://laer.jp/rooms';
      }, 2000);
      return false;
    } else {
      // 終了時間が来るまで毎秒比較
      let lastOneMinutes = false;
      const timeKeep = setInterval(() => {
        if (endDate.getTime() <= (new Date()).getTime()) {
          clearInterval(timeKeep);
          this.isCallEnd = true;
          window.location.href = 'https://laer.jp/rooms';
          return;
        }

        // 通話終了1分前になったらなったら通知を表示
        if ((endHour === new Date().getHours()) && ((endMinutes - 1) === (new Date().getMinutes())) && !lastOneMinutes) {
          lastOneMinutes = true;
          this.snackBar.open('通話終了まであと1分です🍭', '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['pink-snackbar']
          });
          // console.log('通話終了1分前');
        }

        // 通話終了5秒前からカウントダウン表示
        if (lastOneMinutes && (new Date().getSeconds() >= 50)) {
          this.snackBar.open(`通話終了まであと${(60 - new Date().getSeconds())}秒🍬`, '', {
            duration: 1000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['pink-snackbar']
          });
          // console.log('通話終了まで', (60 - new Date().getSeconds()));
        }
      }, 1000);
      return true;
    }
  }

  setOpenTime() {
    const date = new Date();
    if ((this.user.role === AuthService.VTUBER_ROLE) && (typeof this.reservation.vtuberConnectedAt === 'undefined')) {
      this.rs.updateReservationData({
        uid: this.reservationUid,
        vtuberConnectedAt: date
      });
    }
    if ((this.user.role !== AuthService.VTUBER_ROLE) && (typeof this.reservation.userConnectedAt === 'undefined')) {
      this.rs.updateReservationData({
        uid: this.reservationUid,
        userConnectedAt: date
      });
    }
    return;
  }

  initSkyway() {
    // const userType = window.prompt('ユーザー名を入力してください', '');
    // const receiver = window.prompt('通話相手を入力', '');
    this.initUserMedia()
    .then(() => {
      this.peer = new Peer(this.user.uid, {key: environment.skyway});
      // シグナリングサーバ接続後の処理
      this.peer.on('open', () => {
        // console.log('シグナリングサーバに接続完了');
        this.isPeerOpen = true;

        // 表情認識用のデータ通信を接続
        this.connect(this.peer);

        // // 支援者ならVTuberに向けて発信
        // if (this.user.role !== AuthService.VTUBER_ROLE) {
        //   const connect = setInterval(() => {
        //     if (this.isConnected) {
        //       clearInterval(connect);
        //       // console.log('音声接続完了');
        //       // console.log('繰り返し終了');
        //     } else {
        //       const call = this.peer.call(this.partner.uid, this.myAudio);
        //       this.setupCallEventHandlers(call);
        //       // console.log('データ接続が完了するまで音声接続を待つ');
        //     }
        //   }, 10000);
        // }
      });

      // 接続失敗
      this.peer.on('error', err => {
        this.error(err);
        // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
        // this.error('通話の接続に失敗しました');
      });

    //   // 着信時の処理
    //   this.peer.on('call', call => {
    //     // console.log('着信');
    //     call.answer(this.myAudio);
    //     this.setupCallEventHandlers(call);
    // });

      // 通話相手との接続が切れた場合の処理
      this.peer.on('close', () => {
        // this.error('接続が中断されました');
      });

      // シグナリングサーバとの接続が切れた場合の処理
      this.peer.on('disconnected', () => {
        // this.error('接続が中断されました');
      });
    })
    .catch(() => {
      console.log('error');
    });
  }

  initUserMedia() {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices.getUserMedia({                 // メディアデバイスを取得
        video: false,                                       // カメラの映像を使う（スマホならインカメラ）
        audio: true
      })
      .then(stream => {
        // console.log('initUserMedia success');
        this.myAudio = stream;
        resolve();
        return;
      })
      .catch(error => {
        // Error
        this.error('マイクにアクセスできません。デバイスまたはブラウザの設定からマイク入力を許可してください。');
        // console.error('mediaDevice.getUserMedia() error:', error);
        reject();
        return;
      });
    });
  }

  // SFUルームに接続
  connect(peer) {
    // SFUルームに接続
    this.room = peer.joinRoom(this.reservationUid, {mode: 'sfu', stream: this.myAudio});
    this.room.once('open', () => {
      // console.log('room open');
      // this.isConnected = true;
    });
    // 表情認識データを受信した際の処理
    this.room.on('data', data => {
      // console.log('data:', data.data);
      this.theirFace = data.data[0];
      this.theirRotation = data.data[1];
    });
    // 音声を受信した際の処理
    this.room.on('stream', stream => {
      // console.log('音声受信');
      // console.log('stream: ', stream);
      this.isConnected = true;
      this.audio.nativeElement.srcObject = stream;
    });
    // 相手が接続を中断した場合の処理
    this.room.on('peerLeave', peerId => {
      if (this.isCallEnd) {
        this.error('通話が終了しました🍩');
      } else {
        // this.error('接続が中断されました');
        alert(`${this.partner.displayName}さんが通話を一時退室しました。`);
      }
    });

    // // 支援者ならVTuberに向けて発信
    // if (this.user.role !== AuthService.VTUBER_ROLE) {
    //   const connect = setInterval(() => {
    //     if (this.isConnected) {
    //       clearInterval(connect);
    //       // console.log('データ接続完了');
    //       // console.log('繰り返し終了');
    //     } else {
    //       if (this.dataConnection) {
    //         this.dataConnection.close();
    //       }
    //       // console.log('データ接続処理');
    //       // console.log('receiver: ', receiver);
    //       // 表情認識用のデータ通信接続
    //       this.dataConnection = peer.connect(receiver);
    //       this.dataConnection.once('open', async () => {
    //         // console.log('data connected');
    //         this.isConnected = true;
    //       });

    //       this.dataConnection.on('data', data => {
    //         // console.log('データ着信: ', data);
    //         this.theirFace = data[0];
    //         this.theirRotation = data[1];
    //       });

    //       this.dataConnection.once('close', () => {
    //         // this.error('接続が中断されました');
    //         // console.log('データクローズ');
    //       });
    //       // console.log('データがつながるまで繰り返し');
    //     }
    //   }, 10000);
    // } else {
    //   // console.log('データ受信待ち');
    //   // データ受信側
    //   peer.on('connection', dataConnection => {
    //     this.dataConnection = dataConnection;
    //     this.dataConnection.once('open', async () => {
    //       this.isConnected = true;
    //       // console.log('data connected');
    //     });

    //     this.dataConnection.on('data', data => {
    //       // console.log('データ着信: ', data);
    //       this.theirFace = data[0];
    //       this.theirRotation = data[1];
    //     });

    //     this.dataConnection.once('close', () => {
    //       // this.error('接続が中断されました');
    //       // console.log('データクローズ');
    //     });
    //   });
    // }
  }

  // setupCallEventHandlers(call) {
  //   if (this.existingCall) {
  //       this.existingCall.close();
  //   }
  //   this.existingCall = call;

  //   // 音声を受信した際の処理
  //   call.on('stream', stream => {
  //     // console.log('受信');
  //     // console.log('typeof stream: ', typeof stream);
  //     this.isConnected = true;
  //     this.audio.nativeElement.srcObject = stream;

  //     // 音声の再生
  //     // const ctx = new AudioContext();
  //     // const AudioContext = (window as any).AudioContext || (window as any).webkitAudioContext || false;
  //     // if (AudioContext) {
  //     //     // Do whatever you want using the Web Audio API
  //     //     const ctx = new AudioContext;
  //     //     const source = ctx.createMediaStreamSource(stream);
  //     //     source.connect(ctx.destination);
  //     // } else {
  //     //     // Web Audio API is not supported
  //     //     // Alert the user
  //     //     alert('サポート対象外のブラウザまたはデバイスです。');
  //     // }
  //   });

  //   // 通話が終了された際の処理
  //   call.on('close', () => {
  //   });
  // }

  initJeeliz() {
    // Jeelizを初期化
    JEEFACETRANSFERAPI.init({
      canvasId: 'jeefacetransferCanvas',
      NNCpath: '../../assets/js/',
      videoSettings: {
          deviceId: 'default'
      },
      callbackReady: errCode => {
          if (errCode) {
              this.error(`AN ERROR HAPPENS. ERROR CODE = ${errCode}`);
              // this.error('エラーが発生しました。対応していないデバイスかブラウザの可能性があります。');
              return;
          }
          JEEFACETRANSFERAPI.switch_displayVideo(false);
          // console.log('Jeeliz is Ready');

          this.isJeelizReady = true;
      }
    });
  }

  initVrm() {
    // WebGLレンダラーの準備
    const renderer = new THREE.WebGLRenderer();
    renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.setPixelRatio( window.devicePixelRatio );
    this.video.nativeElement.appendChild( renderer.domElement );

    // THREEカメラの準備
    // アバターの肩から上に照準が合うように視点とポジションの数値を設定
    // const camera = new THREE.PerspectiveCamera( 6, window.innerWidth / window.innerHeight, 0.1, 20.0 );
    // camera.position.set( 0.0, 1.47, 4.1 );
    const camera = new THREE.PerspectiveCamera( this.settings[0], window.innerWidth / window.innerHeight, this.settings[1], this.settings[2] );
    camera.position.set( this.settings[3], this.settings[4], this.settings[5] );

    // THREEシーンの準備、背景色の設定
    const scene = new THREE.Scene();
    scene.background = new THREE.Color( 0xf8d8d7 );

    // THREEライトの設定
    const light = new THREE.DirectionalLight( 0xffffff );
    light.position.set( 1.0, 1.0, 1.0 ).normalize();
    scene.add( light );

    // GLTFローダーの準備、VRMモデルの読み込み
    const loader = new GLTFLoader();
    loader.crossOrigin = 'anonymous';
    loader.load(
      this.model,
      ( gltf ) => {
        VRM.from( gltf ).then( ( vrm ) => {
          scene.add( vrm.scene );
          this.currentVrm = vrm;
          vrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.Hips ).rotation.y = Math.PI;
          vrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.LeftUpperArm ).rotation.z = -150;
          vrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.RightUpperArm ).rotation.z = 150;
          const wait = setInterval(() => {
            if (this.theirFace && this.theirRotation) {
                clearInterval(wait);
                this.isModelLoaded = true;
            }
          }, 500);
        } );
      },
      ( progress ) => {
        // console.log( 'Loading model...', 100.0 * ( progress.loaded / progress.total ), '%' )
      },
      ( error ) => {
        this.error(error.message);
        // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。')
      }
    );

    // アバターをrequestAnimationFrameで描画
    const clock = new THREE.Clock();

    const animate = () => {
      requestAnimationFrame( animate );
      const deltaTime = clock.getDelta();
      if ( this.currentVrm && this.isJeelizReady ) {
        // Jeelizから表情・モーションデータを取得
        const face = JEEFACETRANSFERAPI.get_morphTargetInfluencesStabilized();
        const rotation = JEEFACETRANSFERAPI.get_rotationStabilized();
        // 表情・モーションデータを相手に送信
          this.room.send([[face[8], face[9], face[6], face[10]], rotation]);
        // this.dataConnection.send([[face[8], face[9], face[6], face[10]], rotation]);
        // console.log('face: ', face);
        // console.log('theirFace: ', this.theirFace);
        // console.log('rotation: ', rotation);
        // console.log('this.theirRotation: ', this.theirRotation);
        if (this.theirFace && this.theirRotation) {
          // 目の綴じ具合の調整
          let blinkL;
          let blinkR;
          if (this.theirFace[0] === 1 || this.theirFace[1] === 1) {
            blinkL = 1;
            blinkR = 1;
          } else {
            if (this.theirFace[0] < 0.9) {
              blinkL = 0;
            }
            if (this.theirFace[1] < 0.9) {
              blinkR = 0;
            }
          }
          // 表情認識設定
          this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.BlinkL, blinkL );
          this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.BlinkR, blinkR );
          this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.A, this.theirFace[2] );
          this.currentVrm.blendShapeProxy.setValue( VRMSchema.BlendShapePresetName.I, this.theirFace[3] );
          // 表情認識が外れている場合は表情を反映しない
          if (this.theirRotation[2] !== 0) {
            // 顔の向き設定
            const head = this.currentVrm.humanoid.getBoneNode( VRMSchema.HumanoidBoneName.Head ); // VRMのHeadを取得
            const r = [
              (head.rotation._x + -this.theirRotation[0]) * 0.5,
              (head.rotation._y + this.theirRotation[1]) * 0.5,
              (head.rotation._z + -this.theirRotation[2]) * 0.5,
            ];
            // 閾値の設定
            // xは0.1~-0.7, yは-0.5~0.5, zは-0.3~0.3
            if (r[0] > 0.1) {
              r[0] = 0.1;
            } else if (r[0] < -0.7) {
              r[0] = -0.7;
            }
            if (r[1] > 0.5) {
              r[1] = 0.5;
            } else if (r[1] < -0.5) {
              r[1] = -0.5;
            }
            if (r[2] > 0.3) {
              r[2] = 0.3;
            } else if (r[2] < -0.3) {
              r[2] = -0.3;
            }
            // // 閾値の設定2
            // // 値が0.2以上変化している場合は、値の変化を0.2または-0.2にまるめる
            // if ((head.rotation._x - r[0]) > 0.2) {
            //   console.log('7');
            //   // console.log('trueX');
            //   r[0] = head.rotation._x - 0.2;
            // } else if ((head.rotation._x - r[0]) < -0.2) {
            //   console.log('8');
            //   r[0] = head.rotation._x + 0.2;
            // }
            // if ((head.rotation._y - r[1]) > 0.2) {
            //   console.log('9');
            //   // console.log('trueY');
            //   r[1] = head.rotation._y - 0.2;
            // } else if ((head.rotation._y - r[1]) < -0.2) {
            //   console.log('10');
            //   r[1] = head.rotation._y + 0.2;
            // }
            // if ((head.rotation._z - r[2]) > 0.2) {
            //   console.log('11');
            //   r[2] = head.rotation._z - 0.2;
            //   // console.log('trueZ');
            // } else if ((head.rotation._z - r[2]) < -0.2) {
            //   console.log('z: ', head.rotation._z);
            //   console.log('12');
            //   r[2] = head.rotation._z + 0.2;
            // }
            head.rotation.set( r[0], r[1], r[2], 'ZXY' );
          }
        }

        this.currentVrm.update( deltaTime );
      }
      renderer.render( scene, camera );
    };

    animate();
    // console.log(VRMSchema.BlendShapePresetName);
  }

  async initLive2d() {
    // const resourcesDir = '../../../assets/newmint/';
    /**
     * Canvasの初期化
     */

    const canvas = this.canvas.nativeElement;

    /**
     * WebGLコンテキストの初期化
     */

    const gl = canvas.getContext('webgl');

    if (gl === null) {
      return alert('WebGL未対応のブラウザです。');
    }

    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(0.0, 0.0, 0.0, 0.0);
    gl.enable(gl.DEPTH_TEST);
    gl.depthFunc(gl.LEQUAL);

    // フレームバッファを用意
    const frameBuffer: WebGLFramebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);

    /**
     * Frameworkの初期化
     */

    CubismFramework.startUp();
    CubismFramework.initialize();

    /**
     * .model3.jsonファイルを読み込む
     */

    // const model3JsonArrayBuffer = await this.loadAsArrayBufferAsync(`${resourcesDir}newmint.model3.json`)
    const model3JsonArrayBuffer = await this.loadAsArrayBufferAsync(this.model3json)
        .catch(error => {
            this.error(error);
            // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
            return null;
        }) as ArrayBuffer;

    if (model3JsonArrayBuffer === null) {
      this.error('model3JsonArrayBuffer=null');
      // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
      return;
    }

    /**
     * ModelSettingオブジェクトを作成
     */

    const modelSetting = new CubismModelSettingJson(model3JsonArrayBuffer, model3JsonArrayBuffer.byteLength) as ICubismModelSetting;

    /**
     * Live2Dモデルの表示に必要なファイルのパスを設定から取得する
     */

    // .moc3
    // const moc3FilePath = `${resourcesDir}${modelSetting.getModelFileName()}`;

    // テクスチャ
    // const textureFilePathes = [];
    // const textureCount = modelSetting.getTextureCount();
    // for (let i = 0; i < textureCount; i++) {
    //     const textureFilePath = `${resourcesDir}${modelSetting.getTextureFileName(i)}`;
    //     textureFilePathes.push(textureFilePath);
    // }
    // if (textureFilePathes.length === 0) {
    //   return;
    // }


    /**
     * そのほかのファイルのパスを設定から取得する
     */

    // .pose3.json
    // const pose3FilePath = `${resourcesDir}${modelSetting.getPoseFileName()}`;

    /**
     * ファイル、テクスチャをまとめてロード
     */
      const [
        moc3ArrayBuffer,
        textures,
        pose3ArrayBuffer,
        physics3ArrayBuffer
      ] = await Promise.all([
          // this.loadAsArrayBufferAsync(moc3FilePath),   // モデルファイル
          this.loadAsArrayBufferAsync(this.moc3),   // モデルファイル
          // Promise.all(textureFilePathes.map(path => this.createTexture(path, gl))),    // テクスチャ
          Promise.all(this.textures.map(path => this.createTexture(path, gl))),    // テクスチャ
          this.loadAsArrayBufferAsync(this.pose),   // ポーズファイル
          this.loadAsArrayBufferAsync(this.physics)   // 物理演算
      ]);

    if (moc3ArrayBuffer === null) {
      this.error('moc3ArrayBuffer=null');
      // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
      return;
    }


    /**
     * Live2Dモデルの作成と設定
     */

    const model = new AppCubismUserModel();
    // モデルデータをロード
    model.loadModel(moc3ArrayBuffer);
    // 物理演算データをロード
    if (physics3ArrayBuffer !== null) {
      model.loadPhysics(physics3ArrayBuffer, physics3ArrayBuffer.byteLength);
    }
    // ポーズデータをロード
    if (pose3ArrayBuffer !== null) {
      model.loadPose(pose3ArrayBuffer, pose3ArrayBuffer.byteLength);
    }

    // レンダラの作成（bindTextureより先にやっておく）
    model.createRenderer();
    // テクスチャをレンダラに設定
    textures.forEach((texture: WebGLTexture, index: number) => {
        model.getRenderer()
            .bindTexture(index, texture);
    });
    // そのほかレンダラの設定
    model.getRenderer().setIsPremultipliedAlpha(true);
    model.getRenderer().startUp(gl);


    /**
     * Live2Dモデルのサイズ調整
     */

    const projectionMatrix = new CubismMatrix44();
    const resizeModel = () => {
      // console.log('resize');
      // console.log('canvas.clientWidth: ', canvas.clientWidth);
      // console.log('canvas.clientHeight: ', canvas.clientHeight);
      // console.log('devicePixelRatio: ', devicePixelRatio);

        // NOTE: HTMLキャンバスのclientWidth、clientHeightが変わってもwidthとheightは変わらないので、自分で更新する
        // NOTE: スマートフォン向けにdevicePixelRatioを考慮しないとモデルがぼやける
        canvas.width = canvas.clientWidth * devicePixelRatio;
        canvas.height = canvas.clientHeight * devicePixelRatio;

        // NOTE: modelMatrixは、モデルのユニット単位での幅と高さが1×1に収まるように縮めようとしている？
        const modelMatrix = model.getModelMatrix();
        projectionMatrix.loadIdentity();
        // NOTE:
        // 1×1にしたモデルを、キャンバスの縦横比になるように引き延ばそうとする
        // 高さを調整してモデルを正しく表示するには、高さを canvas.width/canvas.height 倍する
        // 幅を調整してモデルを正しく表示するには、幅を canvas.height / canvas.width 倍する
        const canvasRatio = canvas.height / canvas.width;
        // console.log('canvasRatio: ', canvasRatio);
        let translateY;
        let scale;
        // if (1 < canvasRatio) {
        //     // モデルのサイズと表示位置の調整
        //     scale = canvasRatio * 5;
        //     translateY = canvasRatio * 1.4;
        //     // モデルが横にはみ出る時は、HTMLキャンバスの幅で合わせる
        //     projectionMatrix.scale(1, canvas.width / canvas.height);
        // } else {
        //     // モデルのサイズと表示位置の調整
        //     scale = canvasRatio * 5 * (1 - canvasRatio + 1);
        //     translateY = canvasRatio * 1.4 * (1 - canvasRatio + 1);
        //     // モデルが上にはみ出る時は、HTMLキャンバスの高さで合わせる（スマホのランドスケープモードとか）
        //     projectionMatrix.scale(canvas.height / canvas.width, 1);
        // }
        if (1 < canvasRatio) {
            // モデルのサイズと表示位置の調整
            scale = canvasRatio * this.settings[0];
            translateY = canvasRatio * this.settings[1];
            // モデルが横にはみ出る時は、HTMLキャンバスの幅で合わせる
            projectionMatrix.scale(1, canvas.width / canvas.height);
        } else {
            // モデルのサイズと表示位置の調整
            scale = canvasRatio * this.settings[0] * (1 - canvasRatio + 1);
            translateY = canvasRatio * this.settings[1] * (1 - canvasRatio + 1);
            // モデルが上にはみ出る時は、HTMLキャンバスの高さで合わせる（スマホのランドスケープモードとか）
            projectionMatrix.scale(canvas.height / canvas.width, 1);
        }

        projectionMatrix.translateRelative(0, -translateY);


        // モデルが良い感じの大きさになるように拡大・縮小
        projectionMatrix.scaleRelative(scale, scale);

        projectionMatrix.multiplyByMatrix(modelMatrix);
        model.getRenderer().setMvpMatrix(projectionMatrix);

    };
    resizeModel();



    /**
     * Live2Dモデルの描画
     */

    // フレームバッファとビューポートを、フレームワーク設定
    const viewport: number[] = [
      0,
      0,
      canvas.width,
      canvas.height
    ];

    // 呼吸のパラメータ
    let ParamBreath = 0;
    let breathFlag = true;
    // 傾きのパラメータ
    let ParamBodyAngleZ = 0;
    let angleFlag = true;
    const loop = () => {
        // 呼吸の値設定
        if (ParamBreath > 1) {
          breathFlag = false;
        } else if (ParamBreath < 0) {
          breathFlag = true;
        }
        if (breathFlag) {
          ParamBreath += 0.01;
        } else {
          ParamBreath -= 0.01;
        }
        // // 傾きの値設定
        // if (ParamBodyAngleZ > 2) {
        //   angleFlag = false;
        // } else if (ParamBodyAngleZ < -2) {
        //   angleFlag = true;
        // }
        // if (angleFlag) {
        //   ParamBodyAngleZ += 0.03;
        // } else {
        //   ParamBodyAngleZ -= 0.03;
        // }

        if ( this.isJeelizReady ) {
          // Jeelizから表情・モーションデータを取得
          const face = JEEFACETRANSFERAPI.get_morphTargetInfluencesStabilized();
          const rotation = JEEFACETRANSFERAPI.get_rotationStabilized();
          // 表情・モーションデータを相手に送信
          this.room.send([[face[8], face[9], face[6], face[10]], rotation]);
          // this.dataConnection.send([[face[8], face[9], face[6], face[10]], rotation]);
          // console.log('face: ', face);
          // console.log('theirFace: ', this.theirFace);
          // console.log('rotation: ', rotation);
          // console.log('this.theirRotation: ', this.theirRotation);

          if (this.theirFace && (this.theirRotation[2] !== 0)) {
            // 目の綴じ具合の調整
            let blinkL;
            let blinkR;
            if (this.theirFace[0] === 1 || this.theirFace[1] === 1) {
              blinkL = 1;
              blinkR = 1;
            } else {
              if (this.theirFace[0] < 0.9) {
                blinkL = 0;
              }
              if (this.theirFace[1] < 0.9) {
                blinkR = 0;
              }
            }
            // 頂点の更新
            model.update(this.theirFace[3], this.theirFace[2], blinkL, blinkR,
              this.theirRotation[1], this.theirRotation[2], this.theirRotation[0], ParamBreath, ParamBodyAngleZ);
          }
        }
        viewport[2] = canvas.width;
        viewport[3] = canvas.height;
        model.getRenderer().setRenderState(frameBuffer, viewport);

        // モデルの描画
        model.getRenderer().drawModel();

        requestAnimationFrame(loop);

    };
    loop();
    const wait = setInterval(() => {
      if (this.theirFace && this.theirRotation) {
          clearInterval(wait);
          this.isModelLoaded = true;
      }
    }, 500);


    window.onresize = () => {

        resizeModel();

    };
  }


  /**
   * ファイルをArrayBufferとしてロードする
   * @param path ファイルのパス
   */
  async loadAsArrayBufferAsync(path: string): Promise<ArrayBuffer> {

    const response = await fetch(path)
        .catch(error => {
            this.error(error);
            // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
            throw new Error(`Network error: ${error}`);
        });

    if (!response.ok) {
        this.error('!response.ok');
        // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
        throw new Error(`Failed to get "${path}".`);
    }

    const buffer = await response.arrayBuffer()
        .catch(() => {
            this.error('response.arrayBuffer()');
            // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。');
            throw new Error(`Failed to load "${path}" as ArrayBuffer.`);
        });

    return buffer;

  }


  /**
   * テクスチャを生成する
   * @param path テクスチャのパス
   * @param gl WebGLコンテキスト
   */
  async createTexture(path: string, gl: WebGLRenderingContext): Promise<WebGLTexture> {

    return new Promise((resolve: (texture: WebGLTexture) => void, reject: (e: string) => void) => {

        // データのオンロードをトリガーにする
        const img: HTMLImageElement = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {

            // テクスチャオブジェクトの作成
            const tex: WebGLTexture = gl.createTexture();

            // テクスチャを選択
            gl.bindTexture(gl.TEXTURE_2D, tex);

            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

            // 乗算済みアルファ方式を使用する
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 1);

            // テクスチャにピクセルを書き込む
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);

            // ミップマップを生成
            gl.generateMipmap(gl.TEXTURE_2D);

            return resolve(tex);

        };

        img.onerror = error => {
          this.error(error as any);
          // this.error('エラーが発生しました。対応していないデバイスまたはブラウザの可能性があります。')
        };

        img.src = path;

    });
  }

  exit() {
    // console.log('exit');
    const result = window.confirm('通話を退出しますか？ ※通話時間内であれば再入室できます');
    if (result) {
      // this.router.navigate(['/room']);
      window.location.href = 'https://laer.jp/rooms';
    }
  }

  error(error: string) {
    // console.log('error');
    alert(error);
    window.location.href = 'https://laer.jp/rooms';
  }

  mute() {
    if (this.myAudio) {
      const audioTrack = this.myAudio.getAudioTracks()[0];
      // muteする
      audioTrack.enabled = !audioTrack.enabled;
      // console.log('audioTrack.enabled: ', audioTrack.enabled);
      this.muted = !this.muted;
    }
  }

  ngOnDestroy() {
    this.room.close();
    this.peer.destroy();
    location.reload();
  }
}
